import imgHankyu61 from "./tipe 6 (1).png";
import imgHankyu62 from "./tipe 6 (2).png";
import imgHankyu63 from "./tipe 6 (3).png";

const imghankyu6 = [imgHankyu61, imgHankyu62, imgHankyu63];
export default imghankyu6;
